export default __webpack_public_path__ + "static/media/logo-pc-gamepass.35febc01.svg";